import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[200],
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="body2" color="text.secondary" align="center">
          {'© '}
          {new Date().getFullYear()}{' '}
          <Link color="inherit" href="/">
            WebShield
          </Link>{' '}
          - For educational purposes only
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          align="center"
          display="block"
          sx={{ mt: 1 }}
        >
          This tool should only be used on websites you have permission to scan.
        </Typography>
        <Typography 
          variant="caption" 
          color="text.secondary" 
          align="center" 
          display="block" 
          sx={{ mt: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          Developed by{' '}
          <Link 
            href="https://github.com/willFreed1" 
            target="_blank" 
            rel="noopener noreferrer"
            sx={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              ml: 0.5 
            }}
          >
            <GitHubIcon sx={{ fontSize: 16, mr: 0.5 }} />
            willFreed1
          </Link>
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer; 